// extracted by mini-css-extract-plugin
module.exports = {"container":"intro_container__IXUNA","paragraph":"intro_paragraph__LxVmg","button":"intro_button__aIaVJ","externalIconSvg":"intro_externalIconSvg__905ZR"};